/**
 * GPS Tracking Section Layout
 * Provides navigation tabs for GPS features
 */

import React from 'react';
import { Tabs } from 'expo-router';
import { Platform, useWindowDimensions, View, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-native-paper';

const SIDEBAR_WIDTH = 320;

export default function GPSLayout() {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isLargeScreen = width > 1024;
  const theme = useTheme();

  // Adjust tab bar position for sidebar on large screens
  const tabBarStyle = Platform.select({
    ios: {
      backgroundColor: theme.colors.surface,
    },
    android: {
      backgroundColor: theme.colors.surface,
      elevation: 8,
    },
    web: {
      backgroundColor: theme.colors.surface,
      borderTopWidth: 1,
      borderTopColor: theme.colors.outlineVariant,
      // Add margin on large screens to account for sidebar
      ...(isLargeScreen ? {
        marginLeft: SIDEBAR_WIDTH,
        width: `calc(100% - ${SIDEBAR_WIDTH}px)` as any,
      } : {}),
    },
  });

  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: theme.colors.primary,
        tabBarInactiveTintColor: theme.colors.onSurfaceVariant,
        tabBarStyle,
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: t('gps.liveTracking'),
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="navigate" size={size} color={color} />
          ),
        }}
      />
      
      <Tabs.Screen
        name="reports"
        options={{
          title: t('gps.reports'),
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="bar-chart-outline" size={size} color={color} />
          ),
        }}
      />
      
      <Tabs.Screen
        name="alerts"
        options={{
          title: 'Alertas',
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="notifications-outline" size={size} color={color} />
          ),
        }}
      />
      
      <Tabs.Screen
        name="alerts-center"
        options={{
          href: null, // Hide from tab bar
        }}
      />

      <Tabs.Screen
        name="alert-rules"
        options={{
          href: null, // Hide from tab bar
        }}
      />
      
      <Tabs.Screen
        name="geofences"
        options={{
          title: t('gps.geofences'),
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="location-outline" size={size} color={color} />
          ),
        }}
      />
    </Tabs>
  );
}

const styles = StyleSheet.create({});

